import React from 'react';
import { Circle, G, Line, Polygon, Rect, Text as SvgText } from 'react-native-svg';
import { DiagramCanvas } from '../DiagramCanvas';
import { FormulaTag } from '../FormulaTag';
import { LeaderLine } from '../LeaderLine';
import { DT } from '../tokens';

/** Hood face velocity FV = CFM/A — exhaust hood with face area + capture velocity arrows. */
export function DiagramHoodFaceVelocity() {
  // Hood body (canopy)
  const hx = 90, hy = 35, hw = 170, hh = 90;
  // Face opening
  const fx = hx, fy = hy + hh, fw = hw, fh = 16;
  // Duct on top
  const dx = hx + hw / 2 - 22, dy = 18;

  return (
    <DiagramCanvas>
      {/* Exhaust duct */}
      <Rect x={dx} y={dy} width={44} height={20} fill={DT.fill} stroke={DT.stroke} strokeWidth="1.5" />
      <Line x1={dx + 22} y1={dy + 4} x2={dx + 22} y2={dy + 18} stroke={DT.arrow} strokeWidth="1.4" />
      <Polygon points={`${dx + 22},${dy + 4} ${dx + 18},${dy + 11} ${dx + 26},${dy + 11}`} fill={DT.arrow} />

      {/* Hood canopy (trapezoid) */}
      <Polygon points={`${dx},${dy + 20} ${dx + 44},${dy + 20} ${hx + hw},${hy + hh} ${hx},${hy + hh}`}
        fill={DT.fill} stroke={DT.stroke} strokeWidth="1.5" />
      {/* Face plane (highlighted) */}
      <Rect x={fx} y={fy} width={fw} height={fh} fill="rgba(255,107,26,0.15)" stroke={DT.varColor} strokeWidth="1.5" />

      {/* Capture velocity arrows entering face */}
      {[fx + 18, fx + 50, fx + 85, fx + 120, fx + 152].map((cx, i) => (
        <G key={i}>
          <Line x1={cx} y1={fy + fh + 32} x2={cx} y2={fy + fh + 6} stroke={DT.arrow} strokeWidth="1.5" />
          <Polygon points={`${cx},${fy + fh + 4} ${cx - 4},${fy + fh + 11} ${cx + 4},${fy + fh + 11}`} fill={DT.arrow} />
        </G>
      ))}

      {/* Inside-hood capture streamlines (converging up) */}
      {[fx + 30, fx + 80, fx + 130].map((cx, i) => (
        <Line key={`s${i}`} x1={cx} y1={fy} x2={hx + hw / 2} y2={dy + 22}
          stroke={DT.arrow} strokeWidth="0.8" opacity={0.5} strokeDasharray="3,2" />
      ))}

      {/* Face area dimension lines */}
      <Line x1={fx} y1={fy + fh + 60} x2={fx + fw} y2={fy + fh + 60} stroke={DT.dim} strokeWidth="1" />
      <Line x1={fx} y1={fy + fh + 56} x2={fx} y2={fy + fh + 64} stroke={DT.dim} strokeWidth="1" />
      <Line x1={fx + fw} y1={fy + fh + 56} x2={fx + fw} y2={fy + fh + 64} stroke={DT.dim} strokeWidth="1" />
      <SvgText x={fx + fw / 2} y={fy + fh + 70} fill={DT.dim} fontSize="9"
        fontFamily={DT.mono} textAnchor="middle">W (face)</SvgText>
      {/* H of face */}
      <Line x1={fx + fw + 12} y1={fy} x2={fx + fw + 12} y2={fy + fh} stroke={DT.dim} strokeWidth="1" />
      <Line x1={fx + fw + 8} y1={fy} x2={fx + fw + 16} y2={fy} stroke={DT.dim} strokeWidth="1" />
      <Line x1={fx + fw + 8} y1={fy + fh} x2={fx + fw + 16} y2={fy + fh} stroke={DT.dim} strokeWidth="1" />
      <SvgText x={fx + fw + 20} y={fy + fh / 2 + 3} fill={DT.dim} fontSize="9" fontFamily={DT.mono}>H</SvgText>

      {/* Labels */}
      <LeaderLine x1={dx + 22} y1={dy + 18} x2={300} y2={50} varName="CFM" desc="Exhaust airflow" anchor="end" />
      <LeaderLine x1={fx + 80} y1={fy + 8} x2={20} y2={130} varName="A" desc="Face area = W·H" anchor="start" />
      <LeaderLine x1={fx + 100} y1={fy + fh + 20} x2={20} y2={210} varName="FV" desc="Face velocity (FPM)" anchor="start" />

      <FormulaTag formula="FV = CFM / A   (FPM = CFM / ft²)" />
    </DiagramCanvas>
  );
}
